/**
 * Rang-Helfer und Top-3-Auswahl der Kultur-Karten.
 *
 * Portiert aus aivy-pdf-reports (src/reports_v2/components/culture/rank.js).
 * Die Logik ist unverändert, nur der bullet-Filter verträgt zusätzlich
 * einzelne null-Einträge. Die Datei ist bewusst frei von Imports, damit Jest
 * sie ohne Mocks testen kann.
 *
 * selectTopDimensions entscheidet zugleich, ob die Top-3-Bande rendert und
 * welche Zeilen die Rangliste weglässt. Beide Seiten rufen sie mit demselben
 * Argument, ihre Übereinstimmung ist damit strukturell und keine Absprache.
 */

export const pad2 = (value) => (value < 10 ? `0${value}` : `${value}`)

/* Die Culture-Challenge rankt genau 10 Werte, die Skala ist damit 1..10. */
export const MAX_RANK = 10

/* 3, 3.0 und "3" landen alle auf 3, alles andere auf null. Das gilt vor allem
   für Bruchränge und Ränge außerhalb 1..10. Nicht runden und nicht klemmen,
   ein gerundeter Bruchrang wäre ein fremder, plausibel aussehender Rang (2.4
   ergäbe das Badge "02" neben der echten 2). Lieber die Zeile fallen lassen. */
export const toRank = (value) => {
  const rank = Number(value)
  return Number.isInteger(rank) && rank >= 1 && rank <= MAX_RANK ? rank : null
}

/* Die Bande zeigt genau drei Werte. */
export const TOP_DIMENSION_COUNT = 3

/* Identität einer Dimension über die beiden Payload-Arrays hinweg. key zuerst,
   nicht rank. Welche Ränge die Bande zeigt, ist nicht garantiert 1, 2, 3. Fällt
   ein Eintrag ohne bullets raus, rücken 1, 2, 4 nach, und ein Match über den
   Rang träfe die falsche Zeile. */
export const dimensionId = ({ key, rank } = {}) => key || `rank:${rank}`

/* Alles oder nichts. Eine halbleere Bande liest sich als Renderfehler, nicht
   als Design. Das leere Array heißt deshalb zweierlei, die Bande rendert nicht
   und die Rangliste lässt nichts weg. Ein alter Payload ohne top_dimensions
   sieht damit aus wie vor der Erweiterung, und kein Rang kann zwischen den
   beiden Darstellungen verschwinden. */
export const selectTopDimensions = (data) => {
  const dimensions = (Array.isArray(data) ? data : [])
    .map((item) => ({
      ...item,
      rank: toRank(item?.rank),
      title: item?.title || item?.key || '',
      bullets: Array.isArray(item?.bullets)
        ? item.bullets.filter((bullet) => !!bullet?.label && !!bullet?.text)
        : []
    }))
    .filter(({ rank, bullets }) => rank !== null && bullets.length)
    .sort((a, b) => a.rank - b.rank)
    .slice(0, TOP_DIMENSION_COUNT)

  return dimensions.length < TOP_DIMENSION_COUNT ? [] : dimensions
}
